import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type {
  AutoPayIncentivesSettings,
  AutoPayIncentivesSettingsCompanyPortalTypedSettingsWithOverridesDocument,
} from '~/swagger/settings/Api';

const baseUrl = `${envConfig.service.settings}/company-portal/settings/autopayincentives`;

export class AutoPayIncentiveSettingsRepository extends BaseRestRepository {
  public async getAllAutoPayIncentiveSettings(): Promise<AutoPayIncentivesSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = baseUrl + '/with-overrides';
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getAutoPayIncentiveSettingsByLevel(level: string, levelId: string): Promise<AutoPayIncentivesSettings> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateAutoPayIncentiveSettings(payload: AutoPayIncentivesSettings): Promise<AutoPayIncentivesSettings> {
    const url = `${baseUrl}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
      }),
    });
    return this.getJsonResponse(response);
  }

  public async updateAutoPayIncentiveSettingsByLevel(
    level: string,
    levelId: string,
    payload: AutoPayIncentivesSettings
  ): Promise<AutoPayIncentivesSettings> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteAutoPayIncentiveSettingsByLevel(level: string, levelId: string): Promise<void> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }
}
